export interface ScoreInputs {
  metres: number;
  faresPesewas: number;
  closeCalls: number;
  perfectStops: number;
}

export const SCORE = {
  perMetre: 1,
  /** Points per GH₵1 of fares. */
  perCedi: 10,
  perCloseCall: 50,
  perPerfectStop: 150,
  perCoin: 10,
  maxMultiplier: 10,
  /** Black Star ×2 doubles on top of the multiplier. */
  doubleFactor: 2,
  passengersPerMultiplierStep: 5,
} as const;

/** Multiplier grows with how full the trotro is. */
export function multiplierFor(passengersOnBoard: number, fast: boolean): number {
  const base = 1 + Math.floor(passengersOnBoard / SCORE.passengersPerMultiplierStep);
  const withFast = fast ? base * 1.5 : base;
  return Math.min(SCORE.maxMultiplier, withFast);
}

/** Points earned for one event, before the multiplier is applied. */
export function basePoints(inputs: ScoreInputs): number {
  return (
    inputs.metres * SCORE.perMetre +
    (inputs.faresPesewas / 100) * SCORE.perCedi +
    inputs.closeCalls * SCORE.perCloseCall +
    inputs.perfectStops * SCORE.perPerfectStop
  );
}
